import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {locationChangerMixin} from "../../../mixins/location-changer-mixin"

export default {
  mixins: [locationChangerMixin, formBaseMixin],
  title: function () {
    return 'Формирование квитанций'
  },
  data () {
    return {
      fields: {
        date: ''
      }
    }
  },
  methods: {
    /**
     * @override
     */
    getSuccessTitle () {
      return 'Счета отправлены в очередь на формирование'
    },
    /**
     * @override
     * @param fields
     */
    prepareFieldsForSend (fields) {
      return this.prepareLocationFieldsForSend(fields)
    },
    closeForm () {
      this.$refs.modalForm.redirectToPrev()
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    const promises = []
    const endpoints = [
      methods.getItemEndpoint,
      methods.getPostOfficesEndpoint
    ]

    endpoints.forEach(endpointFunc => {
      let endpoint = endpointFunc(route, fromRoute)
      if (endpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint}))
      }
    })

    return promises.length ? Promise.all(promises) : Promise.resolve(true)
  }
}
